/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function (Drupal, $) {
  'use strict';

  // To understand behaviors, see https://www.drupal.org/node/2269515
  Drupal.behaviors.idspThemeMenu = {
    attach: function (context, settings) {
      var self = this;
      var $context = $(context);
      var $body = $('body');

      self.selectors = {
        breadcrumb: '.idsk-header-web__nav-bar--breadcrumbs .govuk-breadcrumbs__list',
        navItem: '.idsk-header-web__nav-list-item',
        subnavItem: '.idsk-header-web__subnav-list-item',
        link: '.idsk-header-web__nav-list-item-link'
      };

      var $menuBtn = $context.find('.idsk-header-web__main-headline-menu-button');

      $menuBtn.on('click', function (e) {
        $body.toggleClass('nav-expanded');
      });

      $context.find('nav.idsk-header-web__nav-bar--buttons').once('header').each(function () {
        var $header = $(this);

        /**
         * Main menu button (open & close)
         */
        var $navItems = $header.find('.idsk-header-web__nav-list ' + self.selectors.navItem + ".has-childs");
        var $subnavItems = $header.find('.idsk-header-web__nav-list ' + self.selectors.subnavItem);
        var $navBreadcrubms = $header.find(self.selectors.breadcrumb);

        // Top level navigation click
        $navItems.on('click', '> ' + self.selectors.link, function (e) {
          e.preventDefault();

          var isOpened = false;
          var $item = $(this).parent();
          var $breadcrumb = $item.find(self.selectors.breadcrumb);

          if($(this).attr('href')) {
            window.location.href = $(this).attr('href');
            return;
          }

          if ($item.hasClass('open')) {
            isOpened = true;
          }

          $navItems.removeClass('open');
          $subnavItems.removeClass('visible');

          if (!isOpened) {
            $item.addClass('open');
            $item.find(self.selectors.subnavItem + '[data-parent="' + $item.data('id') + '"]').addClass('visible');
          }

          $breadcrumb.html(self.breadcrumpTemplate($item.data('id'), 0, $(this).text()));
        });

        $(document).on('click', '.idsk-header-web__brand, .idsk-header-web__main, .mega-menu__backdrop', function (e) {
          $navItems.removeClass('open');
          $subnavItems.removeClass('visible');
        });

        // Megamenu subitems click
        $subnavItems.on('click', '> ' + self.selectors.link, function (e) {
          var $item = $(this).parent();

          if (!$item.hasClass('last')) {
            var $parent = $item.parent('.mega-menu__nav');
            var $breadcrumb = $parent.parent().find(self.selectors.breadcrumb);

            $subnavItems.removeClass('visible');
            $parent.find('[data-parent="' + $item.data('id') + '"]').addClass('visible');
            $breadcrumb.append(self.breadcrumpTemplate($item.data('id'), $item.data('depth'), $item.text()));
          }
        });

        // Breadcrumb click
        $navBreadcrubms.on('click', '.govuk-breadcrumbs__link', function (e) {
          e.preventDefault();

          var $parent = $(this).parent();
          var depth = $parent.data('depth');
          var parent = $parent.data('id');
          var $breadcrumb = $parent.parent();

          $subnavItems.removeClass('visible');
          $navItems.parent().find('[data-parent="' + parent + '"]').addClass('visible');

          $breadcrumb.find('.govuk-breadcrumbs__list-item').each(function (i, item) {
            if ($(item).data('depth') > depth) {
              $(item).remove();
            }
          });
        });

        // Breadcrumb back link
        $('.govuk-breadcrumbs-backlink').on('click', 'a', function (e) {
          e.preventDefault();

          var $items = $(this).parent().parent().find('.govuk-breadcrumbs__list-item');
          var count = $items.length - 2;

          if (count >= 0) {
            $items.eq(count).find('.govuk-breadcrumbs__link').click();
          }
          else {
            $(self.selectors.navItem + '.open ' + self.selectors.link).click();
          }
        });

        /**
         * Main navigation - Expand second level in mobile navigation
         */
        $header.find('.idsk-header-extended__mobile .idsk-header-extended__content > ul.menu > li.menu-item--expanded > .govuk-link').append('<i></i>').each(function () {
          $('> i', this).bind('click', function () {
            var parent_element = $(this).parent().parent();

            if ($(this).hasClass('expand')) {
              $(this).removeClass('expand');
              $('> .sub-nav', parent_element).slideUp(300);
            }
            else {
              $(this).addClass('expand');
              $('> .sub-nav', parent_element).slideDown(300);
            }

            return false;
          });
        });
      });
    },
    breadcrumpTemplate: function (id, depth, text) {
      return '<li class="govuk-breadcrumbs__list-item" data-depth="' + depth + '" data-id="' + id + '"><a class="govuk-breadcrumbs__link" href="#">' + text + '</a></li>';
    }
  };

})(Drupal, jQuery);
